/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { forwardRef } from 'react';
import ArrowLeft from '@atlaskit/icon/glyph/arrow-left';
import ArrowRight from '@atlaskit/icon/glyph/arrow-right';
import { MediaFilmStripListItemSelector } from '.';
import { arrowLeftWrapperStyles, arrowRightWrapperStyles, filmStripListItemStyles, filmStripListStyles, filmStripListWrapperStyles, filmStripViewStyles, shadowLeftStyles, shadowRightStyles } from './styles';
export const ShadowLeft = ({
  children
}) => jsx("div", {
  css: shadowLeftStyles
}, children);
export const ArrowLeftWrapper = ({
  children,
  onClick
}) => jsx("div", {
  css: arrowLeftWrapperStyles,
  className: "arrow",
  onClick: onClick
}, children);
export const ShadowRight = ({
  children
}) => jsx("div", {
  css: shadowRightStyles
}, children);
export const ArrowRightWrapper = ({
  children,
  onClick
}) => jsx("div", {
  css: arrowRightWrapperStyles,
  className: "arrow",
  onClick: onClick
}, children);
export const LeftArrow = ({
  onClick
}) => jsx(ShadowLeft, null, jsx(ArrowLeftWrapper, {
  onClick: onClick
}, jsx(ArrowLeft, {
  label: "left"
})));
export const RightArrow = ({
  onClick
}) => jsx(ShadowRight, null, jsx(ArrowRightWrapper, {
  onClick: onClick
}, jsx(ArrowRight, {
  label: "right"
})));
export const FilmStripViewWrapper = ({
  children,
  'data-testid': dataTestId
}) => jsx("div", {
  css: filmStripViewStyles,
  "data-testid": dataTestId
}, children);
export const FilmStripListWrapper = /*#__PURE__*/forwardRef(({
  children,
  onWheel,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  'data-testid': dataTestId
}, ref) => jsx("div", {
  css: filmStripListWrapperStyles,
  ref: ref,
  onWheel: onWheel,
  onTouchStart: onTouchStart,
  onTouchMove: onTouchMove,
  onTouchEnd: onTouchEnd,
  "data-testid": dataTestId
}, children));
export const FilmStripList = /*#__PURE__*/React.forwardRef(({
  children,
  style
}, ref) => jsx("ul", {
  css: filmStripListStyles,
  ref: ref,
  style: style
}, children));
export const FilmStripListItem = ({
  children,
  index
}) => jsx("li", {
  css: filmStripListItemStyles,
  className: MediaFilmStripListItemSelector,
  "data-testid": "media-filmstrip-list-item",
  key: index
}, children);